import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
  })
export class VoteQService {
  private url = 'http://api.football-family.com/api/v1/getAllVoteQ';
  private url2 = 'https://api.football-family.com/api/v1/votefans';
  private urlA1 = 'https://api.football-family.com/api/v1/getFA1';
  private urlA2 = 'https://api.football-family.com/api/v1/getFA2';
  private urlA3 = 'https://api.football-family.com/api/v1/getFA3';
  private urlAll = 'https://api.football-family.com/api/v1/getFAll';
  
  
  constructor(private http: HttpClient) { }

  getAllQA(data: any){
    return this.http.get(this.url);
  }
  getAllQA1(data: any){
    return this.http.post(this.urlA1,data);
  }
  getAllQA2(data: any){
    return this.http.post(this.urlA2,data);
  }
  getAllQA3(data: any){
    return this.http.post(this.urlA3,data);
  }
  getAllQAll(data: any){
    return this.http.post(this.urlAll,data);
  }
  postQ(data: any) {
    return this.http.post(this.url2, data);
  }
  getfansA(data: any) {
    return this.http.get('http://127.0.0.1:8000/api/v1/getAllVfans');
  }
}